export const BillModel = {
  code: '',
  id: '',
  image: '',
  name: '',
  quantity: 1,
  reference_number: '',
  unit: [],
  batch: [],
  available_stock: 0,
  price: 0,
  bargain_discount: 0,
  isBargained: false,
  comment: '',
};

export class BillDecorator {
  constructor(product) {
    this.product = product;
  }

  toBill() {
    return {
      id: this.product.id ? this.product.id : '',

      quantity: this.product.quantity ? this.product.quantity : 1,
      name: this.product.name ? this.product.name : '',
      selectedProdct: {
        name: this.product.name ? this.product.name : '',
        id: this.product.id ? this.product.id : '',
      },

      unit: this.product.unit ? this.product.units : [],
      unitList: this.product.units ? this.product.units : [],
      batch: this.product.batches ? this.product.batches : null,
      batch_id: this.product.batch_id ? this.product.batch_id : '',
      unit_id: this.product.unit_id ? this.product.unit_id : '',

      amount: this.product.amount ? this.product.amount : 0,
      discount: this.product.discount ? this.product.discount : 0,
    };
  }

  toSell(u) {
    return {
      date: u.date ? u.date : '',
      customer_id: u.customer_id ? u.customer_id : '',
      shop_id: u.shop_id ? u.shop_id : '',
      note: u.note ? u.note : '',
      staff_note: u.staff_note ? u.staff_note : '',
      payment: u.payment ? u.payment : [],

      items: u.items.map((h) => {
        return {
          product_id: h.productid,
          batch_id: h.batch_id,
          unit_id: h.unit_id,
          quantity: h.quantity,
          discount: h.discount,
          amount: h.amount,
        };
      }),
    };
  }
}
